import React from 'react';

const HeroSection = () => {
  return (
    <section className="bg-[#f7fbff] section-spacing-flow">
      <div className="container mx-auto px-4 md:px-28 text-center">
        <h1 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#002d72] leading-[59px] mb-6">Features</h1>
        <p className="text-base sm:text-base md:text-xl lg:text-2xl text-[#202a44] leading-[25px] max-w-[631px] mx-auto">
          Maximize Your Experience with ST-Bridge's Most Popular Features.
        </p>
      </div>
      <div className="container mx-auto px-4 md:px-28 mt-16">
        <hr className="border-[#eaecf0]" />
      </div>
    </section>
  );
};

export default HeroSection;
